import { useState } from "react";
import useTranslation from "@/hooks/use_translation";
import Button from "@/sprout/button";
import { SectionHeader } from "@/sprout/typography";
import Container from "@/components/ui/container";
import { SearchBar } from "@components/job_search/search_bar.tsx";
import { SearchResultCard } from "@components/job_search/search_result_card";
import { SingleSelectFilter } from "@components/job_search/filters/single_select_filter.tsx";
import { MultiSelectFilter } from "@components/job_search/filters/multi_select_filter.tsx";

const JobSearch = () => {
  const { t } = useTranslation("jobSearch");

  const [datePosted, setDatePosted] = useState("");
  const [salary, setSalary] = useState("");
  const [workType, setWorkType] = useState<string[]>([]);
  const [employmentType, setEmploymentType] = useState<string[]>([]);

  const datePostedOptions = [
    t("datePostedOptions.within1Day"),
    t("datePostedOptions.within5Days"),
    t("datePostedOptions.within10Days"),
    t("datePostedOptions.within30Days"),
    t("datePostedOptions.anytime"),
  ];
  const salaryOptions = [
    t("salaryOptions.unspecified"),
    t("salaryOptions.moreThan40k"),
    t("salaryOptions.moreThan60k"),
    t("salaryOptions.moreThan80k"),
    t("salaryOptions.moreThan100k"),
    t("salaryOptions.moreThan120k"),
    t("salaryOptions.moreThan140k"),
    t("salaryOptions.moreThan160k"),
    t("salaryOptions.moreThan180k"),
    t("salaryOptions.moreThan200k"),
  ];
  const workTypeOptions = [
    t("workTypeOptions.remote"),
    t("workTypeOptions.hybrid"),
    t("workTypeOptions.inPerson"),
  ];
  const employmentTypeOptions = [
    t("employmentTypeOptions.fullTime"),
    t("employmentTypeOptions.partTime"),
    t("employmentTypeOptions.contract"),
    t("employmentTypeOptions.temporary"),
  ];

  const resetFilters = () => {
    setDatePosted("");
    setSalary("");
    setWorkType([]);
    setEmploymentType([]);
  };

  const hasActiveFilters = () => {
    return datePosted !== "" || salary !== "" || workType.length > 0 || employmentType.length > 0;
  };

  return (
    <>
      <div className="py-9 pl-7 pr-6 bg-green-100">
        <SearchBar justify={"center"} />
      </div>
      <div className="flex justify-center gap-3 pt-6 pb-5">
        <SingleSelectFilter
          name={t("datePosted")}
          options={datePostedOptions}
          value={datePosted}
          onValueChange={setDatePosted}
        />
        <SingleSelectFilter
          name={t("salary")}
          options={salaryOptions}
          value={salary}
          onValueChange={setSalary}
        />
        <MultiSelectFilter
          name={t("workType")}
          options={workTypeOptions}
          values={workType}
          onValuesChange={setWorkType}
        />
        <MultiSelectFilter
          name={t("employmentType")}
          options={employmentTypeOptions}
          values={employmentType}
          onValuesChange={setEmploymentType}
        />
        <Button
          disabled={!hasActiveFilters()}
          underline
          size="medium"
          shape="none"
          onClick={resetFilters}
        >
          {t("resetFilters")}
        </Button>
      </div>
      <Container className="!max-w-[1550px] !pt-0">
        <SectionHeader>{t("results")}</SectionHeader>
        <SearchResultCard
          title="Project Designer"
          company="Greenhouse"
          location="New York, NY"
          payRange="$100,000 - $200,000"
          logoUrl="https://cdn.prod.website-files.com/62fe5b9ef9e612fe4fed7ff1/63bf4122ced9145885a65b12_g-icon-green.png"
          url="https://my.greenhouse.com"
          publishedAt="Posted 5 days ago"
        />
      </Container>
    </>
  );
};

export default JobSearch;
